import { Observable, ONE_SECOND, elapsed, relativeNow, throttle, addEventListener, monitor } from '@datadog/browser-core';
import { getScrollY } from '../../../browser/scroll';
import { getViewportDimension } from '../../../browser/viewportObservable';
/** Arbitrary scroll throttle duration */

export var THROTTLE_SCROLL_DURATION = ONE_SECOND;
export function trackScrollMetrics(configuration, viewStart, callback) {
  var scrollValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : createScrollValuesObservable(configuration);
  var maxScrollDepth = 0;
  var maxScrollHeight = 0;
  var maxScrollHeightTime = 0;
  var subscription = scrollValues.subscribe(function (_ref) {
    var scrollDepth = _ref.scrollDepth,
        scrollTop = _ref.scrollTop,
        scrollHeight = _ref.scrollHeight;
    var shouldUpdate = false;

    if (scrollDepth > maxScrollDepth) {
      maxScrollDepth = scrollDepth;
      shouldUpdate = true;
    }

    if (scrollHeight > maxScrollHeight) {
      maxScrollHeight = scrollHeight;
      var now = relativeNow();
      maxScrollHeightTime = elapsed(viewStart.relative, now);
      shouldUpdate = true;
    }

    if (shouldUpdate) {
      callback({
        maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
        maxDepthScrollTop: scrollTop,
        maxScrollHeight: maxScrollHeight,
        maxScrollHeightTime: maxScrollHeightTime
      });
    }
  });
  return {
    stop: function stop() {
      return subscription.unsubscribe();
    }
  };
}
export function computeScrollValues() {
  var scrollTop = getScrollY();

  var _getViewportDimension = getViewportDimension(),
      height = _getViewportDimension.height;

  var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
  var scrollDepth = Math.round(height + scrollTop);
  return {
    scrollHeight: scrollHeight,
    scrollDepth: scrollDepth,
    scrollTop: scrollTop
  };
}
export function createScrollValuesObservable(configuration) {
  var throttleDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THROTTLE_SCROLL_DURATION;
  return new Observable(function (observable) {
    function notify() {
      observable.notify(computeScrollValues());
    }

    if (window.ResizeObserver) {
      var throttledNotify = throttle(notify, throttleDuration, {
        leading: false,
        trailing: true
      });
      var observerTarget = document.scrollingElement || document.documentElement;
      var resizeObserver = new ResizeObserver(monitor(throttledNotify.throttled));

      if (observerTarget) {
        resizeObserver.observe(observerTarget);
      }

      var eventListener = addEventListener(configuration, window, "scroll"
      /* DOM_EVENT.SCROLL */
      , throttledNotify.throttled, {
        passive: true
      });
      return function () {
        throttledNotify.cancel();
        resizeObserver.disconnect();
        eventListener.stop();
      };
    }
  });
}